module.exports = __webpack_public_path__ + "static/camera-91273ea4abbb78700f431e8f490bd09c.png";